import { ExistingOrderInfo } from '@/coreInfrastructureModule/axios/generated/unmatchedOrderManage';
import { ExistingOrder } from '../domains/entities/UnmatchedOrderItem';
import { stringToOrderStatusSafe } from '@/coreDomainsModule/entities/arrival';

/**
 * APIレスポンスをUI表示用のExistingOrderに変換する
 */
export class GetExistingOrdersAdapter {
  /**
   * ExistingOrderInfoの配列をExistingOrderの配列に変換する
   * @param orders - APIレスポンスの既存発注データ
   * @returns UI表示用の既存発注データ
   */
  public static adapt(orders: ExistingOrderInfo[]): ExistingOrder[] {
    return orders.map((order) => ({
      orderId: order.orderId,
      warehouseNumber: order.warehouseNumber,
      warehouse: order.warehouse,
      supplierNumber: order.supplierNumber,
      supplierName: order.supplierName,
      businessNumber: order.businessNumber,
      businessName: order.businessName,
      package: Number(order.package),
      orderIssuedNumber: order.orderIssuedNumber ?? undefined,
      orderNumber: order.orderNumber ?? undefined,
      createdOrderDate: order.createdOrderDate ?? undefined,
      desiredDeliveryDate: order.desiredDeliveryDate,
      estimatedTimeOfArrival: order.estimatedTimeOfArrival,
      orderAmount: Number(order.orderAmount),
      orderStatus: stringToOrderStatusSafe(order.orderStatus ?? ''),
      updateAt: order.updateAt,
    }));
  }
}
